import { render } from "./App.vue?vue&type=template&id=312be6fa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=312be6fa&lang=scss"

import exportComponent from "/Users/krisflajs/Projects/DDStudios/DDS-platform/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__